<template>
  <!-- Główny kontener danych o pojeździe: elastyczny układ w wierszach i kolumnach -->
  <div class="vehicle-data d-flex flex-wrap flex-fill">
    <!-- Nagłówek sekcji: nazwa filtrowania danych pojazdu -->
    <h3>{{ $t('vehicle-data').toUpperCase() }}</h3>
    <!-- Przerwa między nagłówkiem a polami filtrów -->
    <div v-if="!shouldHideLocation" class="break"></div>

    <!-- Kontener pól filtrów: dwie kolumny połówkowe -->
    <div class="d-flex vehicle-container">
      <!-- Lewa kolumna filtrów pojazdu -->
      <div class="flex-nowrap vehicle-half">
        <!-- Pojedynczy filtr: rejestracja [=] -- nazwa pola: plateLpr -->
        <single-filter
          :name="$t('registration')"
          symbol="="
          fieldName="plateLpr"
          :isSG="shouldHideLocation"
        />
        <!-- Zakresowy filtr: prędkość [km/h] -->
        <range-filter v-if="!shouldHideLocation"
          :name="$t('speed') + ' [km/h]'"
          :symbolFrom="$t('from')"
          fieldFromName="minSpeed"
          :symbolTo="$t('to')"
          fieldToName="maxSpeed"
        />
        <!-- Zakresowy filtr: masa całkowita [kg] -->
        <range-filter v-if="!shouldHideLocation"
          :name="$t('short-total-weight') + ' [kg]'"
          :symbolFrom="$t('from')"
          fieldFromName="minTotalLoad"
          :symbolTo="$t('to')"
          fieldToName="maxTotalLoad"
        />
        <!-- Zakresowy filtr: długość pojazdu [cm] -->
        <range-filter v-if="!shouldHideLocation"
          :name="$t('length') + ' [cm]'"
          :symbolFrom="$t('from')"
          fieldFromName="minVehLength"
          :symbolTo="$t('to')"
          fieldToName="maxVehLength"
        />
        <!-- Zakresowy filtr: wysokość pojazdu [cm] -->
        <range-filter v-if="!shouldHideLocation"
          :name="$t('height') + ' [cm]'"
          :symbolFrom="$t('from')"
          fieldFromName="minVehHeight"
          :symbolTo="$t('to')"
          fieldToName="maxVehHeight"
        />
      </div>

      <!-- Prawa kolumna filtrów pojazdu -->
      <div class="vehicle-half">
        <!-- Pojedynczy filtr: podobieństwo [%] -->
        <single-filter
          :name="$t('similarity')"
          symbol=">="
          fieldName="similarity"
          :isSG="shouldHideLocation"
        />
        <!-- Zakresowy filtr: liczba osi [szt.] -->
        <range-filter v-if="!shouldHideLocation"
          :name="$t('no-of-axles') + ' [szt.]'"
          :symbolFrom="$t('from')"
          fieldFromName="minNumberOfAxles"
          :symbolTo="$t('to')"
          fieldToName="maxNumberOfAxles"
        />
        <!-- Zakresowy filtr: przeciążenie pojedynczej osi [%] -->
        <range-filter v-if="!shouldHideLocation"
          :name="$t('single-axle') + ' [%]'"
          :symbolFrom="$t('from')"
          fieldFromName="minOverloadSA"
          :symbolTo="$t('to')"
          fieldToName="maxOverloadSA"
        />
        <!-- Zakresowy filtr: przeciążenie wieloosiowe [%] -->
        <range-filter v-if="!shouldHideLocation"
          :name="$t('multiple-axle') + ' [%]'"
          :symbolFrom="$t('from')"
          fieldFromName="minOverloadMA"
          :symbolTo="$t('to')"
          fieldToName="maxOverloadMA"
        />
        <!-- Zakresowy filtr: dopuszczalna masa całkowita [%] -->
        <range-filter v-if="!shouldHideLocation"
          :name="$t('dmc') + ' [%]'"
          :symbolFrom="$t('from')"
          fieldFromName="minOverloadTL"
          :symbolTo="$t('to')"
          fieldToName="maxOverloadTL"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Import store z filtrami archiwalnymi (używany przez te filtry)
import { useArchivalFiltersStore } from "../../stores/archivalFilters";
// Import komponentów obsługujących pola filtrów
import RangeFilter from "./RangeFilter.vue";
import SingleFilter from "./SingleFilter.vue";
// Import funkcji tłumaczeń z vue-i18n
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

export default {
  name: "VehicleData",
  components: { SingleFilter, RangeFilter },
  setup() {
    // Inicjalizacja store'a filtrów archiwalnych
    const filtersStore = useArchivalFiltersStore();
    // Funkcja tłumaczenia kluczy
    const { t } = useI18n();

    const shouldHideLocation = computed(() => {
      const version = process.env.VUE_APP_VERSION_NAME || "";
      return version.startsWith("SG");
    });

    return { filtersStore, t, shouldHideLocation };
  },
  methods: {
    /**
     * Przykładowa metoda ustawiająca filtr na podstawie indeksu
     * @param {number} index - wybrana pozycja
     */
    setFilter(index) {
      this.filtersStore.addItem("VehicleData", index);
    },
  },
};
</script>

<style scoped>
/* Podstawowe marginesy i padding nagłówka */
h3 {
  padding-left: 9px;
}

/* Ustawienia szerokości i minimalnej wysokości kontenera */
.vehicle-data {
  width: 350px;
  /* min-height: 140px; */
  align-content: flex-start; /* <= kluczowe */
  align-items: flex-start;   /* nie rozciągaj dzieci w pionie */
  margin-bottom: 1rem;
}

/* Stylowanie nagłówka wewnątrz vehicle-data */
.vehicle-data h3 {
  margin: 0;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #bfbfbf;
  width: 100%;
  margin-bottom: 1rem;
  flex: 0 0 auto;
}
</style>

<style>
/* Rozmiar fontu dla całej sekcji */
.vehicle-data {
  font-size: 12px;
}
/* Styl etykiet pól filtrów */
.vehicle-data .name {
  font-weight: normal;
  font-size: 12px;
  width: 125px;
  padding: 5px;
  margin: 0;
}
/* Ustawienia szerokości i marginesów dla kolumn */
.vehicle-half {
  /* width: 274px; */
  margin: 3px 35px 10px;
}
/* Wyśrodkowanie kontenera filtrów */
.vehicle-container {
  width: 100%;
  justify-content: center;
}
</style>
